// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1g33K","inputDescription":"styles_inputDescription__LWL9S"};